import React from 'react';

import {
	createProductSpecificAnalyticsIntegrationPayload,
	ErrorType,
	Severity,
	Product,
	Team,
} from '@atlassian/growth-commons-error-analytics';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary';

interface ErrorBoundaryWrapperProps {
	children: React.ReactNode;
	experimentKey: string;
	source: string;
	cohort?: string;
	additionalAttributes?: Record<string, any>;
}

export const ExperimentErrorBoundaryWrapper: React.FC<ErrorBoundaryWrapperProps> = ({
	children,
	experimentKey,
	source,
	cohort,
	additionalAttributes = {},
}) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<TransparentErrorBoundary
			attribution={Attribution.GROWTH_LUNA}
			onError={(error, info) => {
				const eventPayload = createProductSpecificAnalyticsIntegrationPayload({
					product: Product.CONFLUENCE,
					team: Team.GROWTH_LUNA,
					experimentMeta: {
						experimentKey,
						...(cohort && { cohort }),
					},
					errorType: ErrorType.ERROR_BOUNDARY,
					errorMessage: error.message,
					severity: Severity.MEDIUM,
					source,
					additionalAttributes: {
						...info,
						...additionalAttributes,
						errorStack: error.stack,
					},
				});

				createAnalyticsEvent(eventPayload).fire();
			}}
		>
			{children}
		</TransparentErrorBoundary>
	);
};
